import { create } from "zustand";

export const useAppStore = create((set) => ({
    cashPaymentPopup: null,
    setCashPaymentPopup: (cashPaymentPopup) => set({ cashPaymentPopup }),
    glory: false,
    setGlory: (glory) => set({ glory }),
    cashmatic: false,
    setCashmatic: (cashmatic) => set({ cashmatic }),
    unprinted: 0,
    setUnprinted: (unprinted) => set({ unprinted }),
    inventoryPopupVisible: false,
    setInventoryPopupVisible: (inventoryPopupVisible) => set({ inventoryPopupVisible }),
    env: false,
    setEnv: (env) => set({ env }),
    virtualPrinters: [],
    setVirtualPrinters: (virtualPrinters) => set({ virtualPrinters }),
    fiskalyExpiringLoginVisible: false,
    setFiskalyExpiringLoginVisible: (fiskalyExpiringLoginVisible) => set({ fiskalyExpiringLoginVisible }),
    splittedOrders: [],
    setSplittedOrders: (splittedOrders) => set({ splittedOrders }),
    splittedOrdersCount: 0,
    setSplittedOrdersCount: (splittedOrdersCount) => set({ splittedOrdersCount }),
    round: 0,
    setRound: (round) => set({ round }),
    totalBeforeRound: 0,
    setTotalBeforeRound: (totalBeforeRound) => set({ totalBeforeRound }),
    payed: 0,
    setPayed: (payed) => set({ payed }),
}));
